import cornerstone from "cornerstone-core";
import cornerstoneWADOImageLoader from "cornerstone-wado-image-loader";
import dicomParser from "dicom-parser";
import { useEffect, useRef, useState } from "react";

// Initialize cornerstone
cornerstoneWADOImageLoader.external.cornerstone = cornerstone;
cornerstoneWADOImageLoader.external.dicomParser = dicomParser;
cornerstoneWADOImageLoader.configure({
  useWebWorkers: true,
});

interface DicomViewerProps {
  imageId: string;
  currentFrame: number;
  setCurrentFrame: (frame: number) => void;
  currentImg: string;
  setCurrentImg: (currentImg: any) => void;
}

const DicomViewer: React.FC<DicomViewerProps> = ({
  imageId,
  currentFrame,
  setCurrentFrame,
  currentImg,
  setCurrentImg,
}) => {
  const canvasRef = useRef(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setCurrentFrame(0);
    loadImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageId]);

  useEffect(() => {
    renderFrame(currentFrame);
  }, [currentFrame]);

  const loadImage = async () => {
    try {
      const element = canvasRef.current;
      if (element) {
        cornerstone.enable(element);
        const image = await cornerstone.loadAndCacheImage(imageId);
        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        cornerstone.renderToCanvas(canvas, image);
        setCurrentImg(canvas.toDataURL());
      }

      setLoading(false);
    } catch (error) {
      console.error("Error loading DICOM image:", error);
      setLoading(false);
    }
  };

  const renderFrame = async (frame: number) => {
    const element = canvasRef.current;
    if (imageId && element) {
      const image = await cornerstone.loadAndCacheImage(
        `${imageId}?frame=${frame}`
      );
      const canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      cornerstone.renderToCanvas(canvas, image);
      setCurrentImg(canvas.toDataURL());
      // cornerstone.displayImage(element, image);
    }
  };

  return (
    <div style={{ height: "100%" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          overflow: "auto",
        }}
      >
        <img
          style={{ height: "100%", width: "100%" }}
          ref={canvasRef}
          src={currentImg}
          alt={``}
        />
        {loading && <p>Loading DICOM image...</p>}
      </div>
    </div>
  );
};

export default DicomViewer;
